module.exports = __webpack_public_path__ + "fonts/Lato-Thin.454421e7.ttf";